import d1 from "./Images/Illustration/download (8).png";
import d2 from "./Images/Illustration/download (9).png";
import d3 from "./Images/Illustration/download (10).png";
import d4 from "./Images/Illustration/download (5).png";
import d5 from "./Images/Illustration/download (6).png";
import d6 from "./Images/Illustration/download (7).png";
const Service = () => {
    return (
        <section class='container-fluid'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Service</h3>

                    <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Service">Service</li>
                        </ol>
                    </nav></div>

                </div>
                <div class='col-12 py-5'>
                    <h2 className="fw-bold text-center">Latest Service</h2>
                    <div className="row py-4">
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                            <img src={d1} />
                            <h3 className="pt-4">City Transfer</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                            <img src={d2} />
                            <h3 className="pt-4">Air Transfer</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                        <img src={d3} />
                            <h3 className="pt-4">Hospital Transfer</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                    </div>



                    <div className="row py-3">
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                            <img src={d4} />
                            <h3 className="pt-4">Wedding Ceremony</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                            <img src={d5} />
                            <h3 className="pt-4">Whole City Tour</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                        <div className="col-12 col-md-4 border border-2 p-2 text-center shadow">
                        <img src={d6} />
                            <h3 className="pt-4">Baggage Transport</h3>
                            <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
};

export default Service;
